(() => {
  const tabs = [...document.querySelectorAll('[data-category]')];
  const cards = [...document.querySelectorAll('[data-item-category]')];
  tabs.forEach(tab => tab.addEventListener('click', () => {
    const active = tab.dataset.category;
    tabs.forEach(t => {t.classList.toggle('is-current', t===tab);t.setAttribute('aria-pressed', String(t===tab));});
    cards.forEach(card => {card.hidden = active!=='all' && card.dataset.itemCategory!==active;});
  }));
  const variant = document.querySelector('[data-variant-select]');
  const price = document.querySelector('[data-product-price]');
  variant?.addEventListener('change', () => {const selected=variant.selectedOptions[0];if(price && selected?.dataset.price)price.textContent=selected.dataset.price;});
  const qty = document.querySelector('#ProductQuantity');
  document.querySelectorAll('[data-qty]').forEach(btn => btn.addEventListener('click',() => {
    if(!qty)return;
    qty.value = Math.max(1, (parseInt(qty.value,10)||1) + (btn.dataset.qty==='plus'?1:-1));
  }));
})();
